import React from 'react';

import { Box } from 'ui/box';

import Breadcrumbs from 'components/partials/beadcrumbs/breadcrumbs';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';

interface BreadcrumbData {
  label: string;
  href?: string;
  isActive?: boolean;
}

interface HeroContentTypeProps {
  title?: string;
  description?: string;
  breadcrumbs?: BreadcrumbData[];
  customClass?: string;
}

const HeroContentType = ({
  title = '',
  description = '',
  breadcrumbs = [],
  customClass = '',
}: HeroContentTypeProps): React.JSX.Element => (
  <div
    className={`bg-navy-50 flex flex-col w-full items-center pb-16 ${customClass}`}
  >
    <ResponsiveWrapper customClass="flex flex-col">
      <Box sx={{ '@media (min-width: 780px)': { width: '600px' } }}>
        <Breadcrumbs breadcrumbs={breadcrumbs} customClass="!mt-0 mb-9" />
        <div>
          <h1 className="text-5xl font-semibold text-navy-800 mb-4">{title}</h1>
          <Box
            sx={{
              fontWeight: 400,
              color: 'tokens.navy.800',
              mb: 2,
              '@media (min-width: 375px)': {
                fontSize: '1.125rem',
                lineHeight: '1.75rem',
              },
              '@media (min-width: 780px)': {
                fontSize: '1.25rem',
                lineHeight: '1.75rem',
              },
            }}
          >
            {description}
          </Box>
        </div>
      </Box>
    </ResponsiveWrapper>
  </div>
);

export default HeroContentType;
